<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container v-if="show">
            <AllYearResultCard  :Vipstatus="anaResult.Vipstatus" :listdata="Allyearresult" v-on:sendAction="PaymentPopup"  ></AllYearResultCard>
        </b-container>
        <PaymentModel :product="productName" :point="Price" v-on:sendAction="GoPayment"></PaymentModel>
        <AnaLoading :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import AllYearResultCard from '@/components/AllYearResultCard2.vue'
import PaymentModel from '@/components/PaymentModel.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {alertModel} from '@/service/commuse'

export default {
  name: 'Personality',
  components: {Nav,PageHeader,AllYearResultCard,PaymentModel,AnaLoading},
  data () {
    return {
      productName:'個人流年',
      pageloading:false,
      puid:'1',
      Result:{

      },
      show:false
    }
  },
  created(){
    this.pageloading=true
    this.$store.dispatch('actionAnaResult', {
      producttype:'AllyearFree'
    }).then((res) => {
      this.show=true
      this.pageloading=false
    }).catch((res) => {
      this.pageloading=false
    });
  },
  computed:{
    ...mapState(['productdata','anaResult']),
    Price:function () {return this.productdata.data.find(x => x.id === this.puid).price},
    Allyearresult:function () {return Object.keys(this.anaResult).length === 0 ? []: this.anaResult.Allyear;}

  },
  methods: {
    PaymentPopup () {

      this.$store.dispatch('actionGetCurencyPlan', {})
        .then((res) => {
          if(res.data.point == 9999999){
            this.GoPayment()
          }else{
            this.$bvModal.show('PaymentModel')
          }
        }).catch((res) => {
        this.$bvModal.show('PaymentModel')
      });
    },
    GoPayment () {

      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        producttype:'AllyearVip'
      }).then((res) => {
        setTimeout(()=>{
          this.pageloading = false
          this.$router.push('/Allyear');
        },3000)
      }).catch((res) => {
        this.pageloading = false
        alertModel(this,'系統訊息','點數餘額不足')
      });
    }

  }
}
</script>

<style scoped>

</style>
